/* Folliva Clear 2026-10-15 (Oliver, v9): the selected size card opens with plan details.
   - another card picked → it opens, the old one closes (CSS animates the height)
   - Free Starter Kit row opens and closes on tap / Enter
   - Autoship ticked or not → the billing line and price per day are reprinted from the card's price
   - the Autoship line under the tick box reads the card's weeks ("Every 8 weeks · cancel anytime")
   Markup: snippets/fc-plan-kit.liquid. Settings: Variant picker → Plan details. */
(function () {
  "use strict";
  function money(c) {
    if (window.FL && FL.money) return FL.money(c);
    return "€" + (c / 100).toFixed(2).replace(".", ",");
  }
  function place(card) {
    var w = card.querySelector("[data-fx]"); if (!w) return;
    var cs = getComputedStyle(card);
    card.style.setProperty("--fx-rg", cs.rowGap === "normal" ? "0px" : cs.rowGap);
    var tl = card.querySelector(".fl-vcard__tl") || card.querySelector(".fl-vcard__size");
    var dotH = parseFloat(getComputedStyle(card, "::before").height) || 22;
    if (tl) {
      var cr = card.getBoundingClientRect(), tr = tl.getBoundingClientRect();
      card.style.setProperty("--fx-dot", (tr.top - cr.top + tr.height / 2 - dotH / 2) + "px");
    }
    w.style.marginLeft = (-(parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight))) + "px";
  }
  function bind(card) {
    var w = card.querySelector("[data-fx]"); if (!w || w.__fx) return; w.__fx = true;
    var row = w.querySelector(".fx-row");
    if (row) {
      var toggle = function (e) {
        e.preventDefault(); e.stopPropagation();
        var k = row.parentElement, o = !k.classList.contains("is-open");
        k.classList.toggle("is-open", o); row.setAttribute("aria-expanded", String(o));
        if (o) revealKit(k);
      };
      row.addEventListener("click", toggle);
      row.addEventListener("keydown", function (e) { if (e.key === "Enter" || e.key === " ") toggle(e); });
    }
    /* taps inside the open panel must not re-trigger the card's label */
    w.addEventListener("click", function (e) { if (!e.target.closest(".fx-row")) { e.preventDefault(); e.stopPropagation(); } });
  }
  function sync(deck) {
    var root = deck.closest(".shopify-section") || document;
    var tick = root.querySelector("[data-fl-subs-toggle]");
    var subOn = !!(tick && tick.checked && !tick.disabled);
    var sel = null;
    deck.querySelectorAll("[data-fl-card]").forEach(function (card) {
      var open = !!card.querySelector("input:checked");
      if (open) sel = card;
      card.classList.toggle("fx-open", open);
      var w = card.querySelector("[data-fx]"); if (!w) return;
      if (!open) {
        var k = w.querySelector(".fx-kit");
        if (k) { k.classList.remove("is-open"); var r = k.querySelector(".fx-row"); if (r) r.setAttribute("aria-expanded", "false"); }
      }
      var weeks = parseInt(w.getAttribute("data-weeks"), 10) || 0;
      var pr = card.querySelector("[data-fl-card-price]");
      var cents = pr ? parseInt(pr.getAttribute("data-fl-cents"), 10) : NaN;
      if (weeks > 0 && isFinite(cents)) {
        var bill = w.querySelector("[data-fx-bill]"), day = w.querySelector("[data-fx-day]");
        if (bill) bill.textContent = subOn
          ? (w.getAttribute("data-bill") || "").replace("{price}", money(cents)).replace("{weeks}", weeks)
          : (w.getAttribute("data-once") || "");
        if (day) day.textContent = money(Math.floor(cents / (weeks * 7)));
      }
    });
    /* the kit goes to the order as a note on the product line (no separate €0 lines: the pixels would count
       every gift as another add-to-cart). Empty for a size without a kit. */
    var form = root.querySelector("form[data-fl-product-form]");
    var sw = sel && sel.querySelector("[data-fx]");
    var pname = sw && sw.getAttribute("data-prop-name"), pval = sw && sw.getAttribute("data-prop");
    if (form) {
      var inp = form.querySelector("input[data-fx-prop]");
      if (!inp) { inp = document.createElement("input"); inp.type = "hidden"; inp.setAttribute("data-fx-prop", ""); form.appendChild(inp); }
      if (pname && pval) { inp.name = "properties[" + pname + "]"; inp.value = pval; } else { inp.removeAttribute("name"); inp.value = ""; }
    }
    if (sel) {
      var meta = root.querySelector("[data-fl-subs-meta]");
      var w2 = sel.querySelector("[data-fx]");
      var txt = w2 && w2.getAttribute("data-meta");
      if (meta && txt) meta.textContent = txt;
    }
  }
  /* 2026-10-15 (Oliver): a card the customer opens slides fully into view — its top just under the sticky header —
     and an opened kit is scrolled up enough to show its last line. Runs after the open animation. */
  /* the sticky header: what it covers now, and its full height (it slides back in when the page scrolls up) */
  function header() {
    var vis = 0, full = 0;
    document.querySelectorAll(".fl-header, header, [id$='__header']").forEach(function (h) {
      var cs = getComputedStyle(h), r = h.getBoundingClientRect();
      if (cs.position !== "sticky" && cs.position !== "fixed") return;
      if (r.height < window.innerHeight / 3) full = Math.max(full, r.height);
      if (r.top <= 1 && r.bottom > vis && r.bottom < window.innerHeight / 3) vis = r.bottom;
    });
    return { vis: vis, full: full };
  }
  function headerBottom(goingUp) { var h = header(); return goingUp ? Math.max(h.vis, h.full) : h.vis; }
  var still = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  function revealCard(card) {
    setTimeout(function () {
      var r = card.getBoundingClientRect(), up = r.top < 0, top = headerBottom(up) + 12;
      if (r.top < top || r.bottom > window.innerHeight - 12) window.scrollTo({ top: window.scrollY + r.top - top, behavior: still ? "auto" : "smooth" });
    }, still ? 0 : 480);
  }
  function revealKit(kit) {
    setTimeout(function () {
      var top = headerBottom() + 12, r = kit.getBoundingClientRect(), over = r.bottom - (window.innerHeight - 16);
      if (over > 0) window.scrollTo({ top: window.scrollY + Math.min(over, r.top - top), behavior: still ? "auto" : "smooth" });
    }, still ? 0 : 460);
  }
  function init(deck) {
    if (deck.__pk) return; deck.__pk = true;
    var cards = deck.querySelectorAll("[data-fl-card]");
    cards.forEach(function (c) { place(c); bind(c); });
    sync(deck);
    var root = deck.closest(".shopify-section") || document;
    /* fl-product.js reprices the cards on the same change events; read them a frame later */
    root.addEventListener("change", function (e) {
      var picked = e.isTrusted && e.target && e.target.closest ? e.target.closest("[data-fl-card]") : null;
      requestAnimationFrame(function () { sync(deck); if (picked && deck.contains(picked) && picked.classList.contains("fx-open")) revealCard(picked); });
    });
    window.addEventListener("resize", function () { cards.forEach(place); });
    window.addEventListener("load", function () { cards.forEach(place); sync(deck); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { cards.forEach(place); });
  }
  function boot() { document.querySelectorAll(".fl-vcards--pk").forEach(init); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot); else boot();
  document.addEventListener("shopify:section:load", boot);
})();
